//---- components ---------
//---- mixins -------------
//---- services -----------
//---- other --------------
import routes from '../../routes.js';
//---- 3rd-parties --------
import { mapGetters } from "vuex";

export default {

  computed: {

    ...mapGetters({
      backendConnectivity: "kmOffline/isConnected",
      isKMOffline: "kmOffline/isKMOffline",
      kmOfflineStatus: "kmOffline/status",
      soloBackendNotRunning: "kmOffline/soloBackendNotRunning",
    }),

    hServiceConnectivity() {
      return this.backendConnectivity?.hServiceConnectivity;
    },

    backendInternetConnectivity() {
      return this.backendConnectivity?.backendInternetConnectivity;
    },

    // used for online to know if we should display the component or not
    hasKMOfflineRegistrationHash() {
        const currentHash = routes.currentRoute.hash;
        return currentHash.includes("kmOfflineRegistration");
        },

    registrationRequired() {
        if (this.isKMOffline) 
            return !this.kmOfflineStatus?.hasValidDisconnectedKey || !this.kmOfflineStatus?.isInitialized;
        else
            return this.hasKMOfflineRegistrationHash;
    },

    keyValidityDays() {
        return this.kmOfflineStatus?.disconnectedKeyValidity;
    }
  }

}